// react
import { useState } from 'react';

const deserializeStoredValue = (storedValue) => {
  try {
    return JSON.parse(storedValue);
  } catch {
    return storedValue;
  }
};

function getStorageValue(key, defaultValue) {
  if (typeof window === 'undefined') return defaultValue;

  try {
    const storedValue = window.localStorage.getItem(key);
    if (storedValue === null) return defaultValue;
    return deserializeStoredValue(storedValue);
  } catch {
    return defaultValue;
  }
}

export const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => getStorageValue(key, defaultValue));

  const setStoredValue = (valueOrUpdater) => {
    setValue((previousValue) => {
      const nextValue =
        typeof valueOrUpdater === 'function'
          ? valueOrUpdater(previousValue)
          : valueOrUpdater;

      try {
        window.localStorage.setItem(key, JSON.stringify(nextValue));
      } catch {
        // Ignore storage failures and keep in-memory state.
      }

      return nextValue;
    });
  };

  return [value, setStoredValue];
};
